import React from 'react';

const LandingContent = () => {
    return (
        <div>
            <section className="bg-white dark:bg-gray-900 text-left">
                <div
                    className="gap-16 items-center py-8 px-4 mx-auto h-96 max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-8 lg:px-6">
                    <div className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
                        <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
                            How it works?
                        </h2>
                        <p className="mb-4">
                            With Dimensions, you can input a few words that describe the desired textures of your model
                            and watch as Dimensions produces amazing results in mere moments.
                        </p>
                        <p>
                            The technology uses natural language processing, deep learning algorithms and generative
                            neural networks to create unique textures every time.
                        </p>
                    </div>
                    <div className="min-h-full grid grid-cols-2 gap-4">
                        <div className="font-light text-gray-500 sm:text-lg dark:text-white text-center" width='100%'
                             height='100%'>
                            <p className="mt-8 -mb-8">Original asset</p>
                            <iframe
                                src='https://my.spline.design/axeoriginal-7b04c18a0d43cfccfbdd2866942e0118/'
                                frameBorder='0'
                                width='100%'
                                height='100%'
                            />

                        </div>

                        <div className="font-light text-gray-500 sm:text-lg dark:text-white text-center" width='100%'
                             height='100%'>
                            <p className="mt-8 -mb-8">Winter style</p>
                            <iframe
                                src='https://my.spline.design/axewinter-ec0901276acb059cf693e485ebdbd1be/'
                                frameBorder='0'
                                width='100%'
                                height='100%'
                            />

                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LandingContent;